import IndicatorForm from '@/components/forms/indicatorForm/indicatorForm';
import IndicatorsTableView from '@/components/indicators/IndicatorsTableView';
import { Command, CommandInput } from '@/components/shadcn/ui/command';
import { toast } from '@/components/shadcn/ui/use-toast';
import { Indicator } from '@/entities/indicator';
import { useIndicators } from '@/hook/useIndicators';
import { useEffect, useState } from 'react';
import { collapseTextChangeRangesAcrossMultipleVersions } from 'typescript';
import { IndicatorProvider } from '@/context/IndicatorContex';
import PhoneMaskUtils from '@/utils/PhoneMaskUtils';
import React from 'react';
const IndicatorsPage = () =>{
  const {indicators, createIndicator, updateIndicator, deleteIndicator, searchIndicator, searchedIndicators} = useIndicators();
  const [indicatorsPage, setIndicator] = useState<Indicator[]>([]);
  const [open, setOpen] = useState(false);
  const [isEdit, setEdit] = useState(false);
  const [IndicatorToEdit, setIndicatorToEdit] = useState(false);
  
  useEffect(()=>{
    setIndicator(indicators);
  },[indicators]);
  
  const onIndicatorDelete = async (index:number,data:any) => {
    const success = await deleteIndicator(data.id);
    if(success){
      const newList = [...indicatorsPage];
      newList.splice(index, 1);
      setIndicator(newList);    
      toast({
        description: 'Indicador apagado com sucesso!',
      });
    }else {
      toast({
        title: 'Erro!',
        description: 'Indicador não pode possuir vinculo a nenhum negocio',
      });
    }
  };

  const handleIndicatorSubmit = async (data:any) => {
    try{
      let comissao;
      if (typeof data.commission === 'string'){
        comissao = data.commission.includes('.') 
          ? data.commission.replaceAll('.','').replace(',','.') : data.commission.includes(',') 
            ? data.commission.replace(',','.') : data.commission;
      } else{
        comissao =  data.commission;
      }

      const indicatorForCreation = {
        name:data.name,
        email: data.email,
        phone: data.phone,
        commission: Number(comissao),
      };
      const created = await createIndicator(indicatorForCreation);
      if(created){
        const i = {
          id: created.id,
          name: created.name,
          email: created.email,
          phone: PhoneMaskUtils.unformat(created.phone),
          commission: created.commission,
        };
        setIndicator([...indicators, i]);
        setOpen((open) => !open);
        toast({
          description: 'Indicador criado com sucesso!',
        });
      }
      else{
        toast({
          title: 'Erro!',
          description: 'Indicador indefinido.',
        });
      }

    }catch(e){
      toast({
        title: 'Erro!',
        description: 'Um erro ocorreu na criação do indicador.',
      });
    }
  };

  const removeAcentos = (text: string): string => {
    if (!/[áàâãäÁÀÂÃÄéêëÉÊËíîïÍÎÏóòôõöÓÒÔÕÖúùûüÚÙÛÜ]/.test(text)) {
      // Se não houver caracteres acentuados, retorna a string original
      return text;
    }
    
    return text
      .normalize('NFD') // Normaliza a string
      .replace(/[\u0300-\u036f]/g, ''); // Remove os acentos
  };

  const handleEditIndicator = (index:number, indicador:any) => {
    try{
      let comissao;
      if (typeof indicador.commission === 'string'){
        comissao = indicador.commission.includes('.') 
          ? indicador.commission.replaceAll('.','').replace(',','.') : indicador.commission.includes(',') 
            ? indicador.commission.replace(',','.') : indicador.commission;
      } else{
        comissao =  indicador.commission;
      }
  
      const indicatorUpdate = {
        id: indicatorsPage[index].id,
        name: indicador.name,
        email: indicador.email,
        phone: PhoneMaskUtils.unformat(indicador.phone),
        commission: Number(comissao)
      };
      indicatorsPage[index].name = indicador.name;
      indicatorsPage[index].email = indicador.email;
      indicatorsPage[index].phone = indicador.phone;
      indicatorsPage[index].commission = comissao;

      updateIndicator(indicatorUpdate.id, indicatorUpdate);
      setOpen((open) => !open);
      toast({
        description: 'Indicador editado com sucesso!',
      });
    }catch(e){
      toast({
        title: 'Erro!',
        description: `Um erro ocorreu na edição do indicador: ${e}`,
      });
    }
  };

  const EditOrCreateSubmit = (index:number | undefined, data:any) => {
    if(data !== undefined && index === undefined){
      handleIndicatorSubmit(data);
    }
    else if(index !== undefined){
      handleEditIndicator(index, data);
    }
  };

  return (
    <IndicatorProvider>
      <div className='min-h-screen bg-indigo-200 p-8'>
        <div className='min-h-100 flex flex-col overflow bg-white rounded-md py-4 mx-8 mb-4 '>   
          <div className='flex m-2 justify-between items-center pr-2'>
            <h1 className='m-4 text-md font-medium'>Indicadores</h1>
            <div className='flex gap-6'>
              <IndicatorForm onIndicatorSubmit={EditOrCreateSubmit}/>
              <Command className='flex items-center rounded-lg border-2 p-1 gap-1'>
                <CommandInput 
                  onChangeCapture={(e) => { 
                    const target = e.target as HTMLInputElement;
                    if(target.value!=''){
                      searchIndicator(target.value);
                      setIndicator(searchedIndicators.map((i) => ({
                        id: i.id,
                        name: i.name,
                        phone: i.phone,
                        email: i.email,
                        commission: i.commission,
                        createdAt: i.createdAt
                      })));
                    } else if(target.value === '' || searchedIndicators.length === 0){
                      setIndicator(indicators);
                    }
                  }} 
                  placeholder="Pesquisar..."/>
              </Command>
            </div>
          </div>
          <div>
            <IndicatorsTableView
              onIndicatorDelete={onIndicatorDelete}
              data={indicatorsPage}
            />
          </div>
        </div>
      </div>
    </IndicatorProvider>
  );
};

export default IndicatorsPage;
